import React, { ReactElement, useEffect } from 'react'
import Divider from '../../Divider'
import WalletsOverview from './WalletsOverview'
import { ArtData } from '@/database/art'

const WalletsPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        window.location.hash = `#nft-${artData?.tokenId + tabName}#wallets`
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <WalletsOverview artData={artData} />
        </div>
    )
}

export default WalletsPanel
